// Same-origin paths — vercel.json rewrites /api/v1/admin/* to the Railway backend.
// SuccessResponse[T] envelope: backend returns { success, data, ... } so callers
// just want the inner data; on error, surfaces the user-readable message.

export async function callApi(path, { method = 'GET', body, accessToken } = {}) {
  const res = await fetch(path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = json?.detail || json;
    throw new Error(detail?.message || `${res.status} ${res.statusText}`);
  }
  return json.data ?? json;
}
